import { inmunetApi } from '../../../api';

export const getPacientePruebaAlergia = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/pruebaAlergia/${id}`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.pruebaAlergia;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};